import { render, staticRenderFns } from "./PCToolbox.vue?vue&type=template&id=4975bd2e&scoped=true"
import script from "./PCToolbox.vue?vue&type=script&lang=js"
export * from "./PCToolbox.vue?vue&type=script&lang=js"
import style0 from "./PCToolbox.vue?vue&type=style&index=0&id=4975bd2e&prod&lang=scss"
import style1 from "./PCToolbox.vue?vue&type=style&index=1&id=4975bd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975bd2e",
  null
  
)

export default component.exports